import { Tool } from "./tool";
import { state, store, scene } from "../store";
import { rerender } from "../renderer/renderer";

const MoveTool: Tool = {
    name: '(M)ove',
    icon: 'fullscreen',
    shortcut: 'm',
    onMouseMove: (delta: number[]) => {
        if (state.object && state.object.translate) {
            if (store.dragging) {
                state.object.translate[0] = (Number(state.object.translate[0]) || 0) + delta[0]*scene.scale;
                state.object.translate[1] = (Number(state.object.translate[1]) || 0) + delta[1]*scene.scale;
                rerender();
            }
        }
    }
};

export { MoveTool };
